import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const summaryRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
});

export const deltaIcon = css({
  width: '20px',
  height: '20px',
  flexShrink: 0,
});

export const summaryDelta = css({
  fontSize: 'xl',
  fontWeight: '700',
  lineHeight: '1.2',
});

export const description = css({
  fontSize: 'md',
  color: 'hpxBlue500',
  lineHeight: '1.5',
});

export const inlineDelta = css({
  fontWeight: 'bold',
});

export const colorCheaper = css({
  color: 'hpxTeal500',
});

export const colorMore = css({
  color: 'hpxRed400',
});

// HALO link treatment: teal + bold, underline only on hover (matches BuildingWebsiteLink,
// PropertyManagerModule phone link).
export const inlineLink = css({
  color: 'hpxTeal500',
  fontWeight: 'bold',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const averagesCardHeader = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginTop: 0,
  marginBottom: '1x',
});

export const averagesList = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

// Row styles mirror CostAndFeesModule's summaryRow — grey key, bold blue value.
// Here the key is a link (teal on hover) since it navigates to the area SRP.
export const areaRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '2x',
  minWidth: 0,
  paddingY: 'xs',
  fontSize: 'md',
});

export const areaRowLink = css({
  color: 'hpxTeal500',
  fontWeight: 'bold',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
    color: 'hpxTeal600',
  },
});

export const areaRowValue = css({
  color: 'hpxBlue600',
  fontWeight: 'bold',
});
